import React, { useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { MenuCategories as View } from '@views';
import { routes } from '@constants';
import { getMenuCategories, getMenuSubcategories } from '@helpers/menuItems';

const MenuCategories = () => {
  const { categories, subcategories } = useSelector(state => state.menu);

  const location = useLocation();

  const [hasServerError, setHasServerError] = useState(false);

  useEffect(() => {
    if (location.state && location.state.categoryCreated) {
      window.scrollTo(0, document.body.scrollHeight);

      const newCategory = document.getElementById(`category-${categories.sortedIds[categories.sortedIds.length - 1]}`);

      newCategory.scrollIntoView();
    }
  }, []);

  const handleToastClose = () => {
    setHasServerError(false);
  };

  const history = useHistory();

  const handleCategorySelect = categoryId => () => {
    history.push({
      pathname: routes.menuItems,
      state: {
        selectedCategoryId: categoryId,
      },
    });
  };

  const memoizedCategories = useMemo(() => getMenuCategories(categories), [categories]);

  const memoizedSubcategories = useMemo(() => getMenuSubcategories(subcategories, categories), [subcategories]);

  return (
    <View
      onToastClose={handleToastClose}
      hasServerError={hasServerError}
      categories={memoizedCategories}
      subcategories={memoizedSubcategories}
      onCategorySelect={handleCategorySelect}
    />
  );
};

export default MenuCategories;
